import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const AutomaticSessionSchema = BaseEventSchema.extend({
  type: z.enum(['phone', 'email']),
});

export enum AutomaticEventTypes {
  SessionVerificationCodeSent = 'automatic.session.verification_code_sent',
  SessionBiometricLoginAttempt = 'automatic.session.biometric_login_attempt',
  SessionBiometricLoginSuccess = 'automatic.session.biometric_login_success',
  SessionLogout = 'automatic.session.logout',
  SessionLoginSuccess = 'automatic.session.login_success',
  SessionVerificationCodeSuccess = 'automatic.session.verification_code_success',
}

export const AutomaticEventTrackingSchemas = {
  [AutomaticEventTypes.SessionVerificationCodeSent]: AutomaticSessionSchema,
  [AutomaticEventTypes.SessionBiometricLoginAttempt]: BaseEventSchema,
  [AutomaticEventTypes.SessionBiometricLoginSuccess]: BaseEventSchema,
  [AutomaticEventTypes.SessionLogout]: BaseEventSchema,
  [AutomaticEventTypes.SessionLoginSuccess]: BaseEventSchema,
  [AutomaticEventTypes.SessionVerificationCodeSuccess]: BaseEventSchema,
};
